export const FETCHING_DENIAL_REASONS = 'FETCHING_DENIAL_REASONS';
export const FAILED_FETCHING_DENIAL_REASONS = 'FAILED_FETCHING_DENIAL_REASONS';
export const SUCCESSFULLY_RECEIVED_DENIAL_REASONS = 'SUCCESSFULLY_RECEIVED_DENIAL_REASONS';
